export const API_URL = import.meta.env.VITE_API_URL;
export const APP_ENV = import.meta.env.VITE_APP_ENV;
export const STRIPE_PUBLIC_KEY = import.meta.env.VITE_STRIPE_PUBLIC_API_KEY;
export const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY;
